// unit: filter3
import f from "../../../../funcs";


let Operator = f.CreateClass("Operator", {
    init(literal) {
        this.literal = literal;
    },

    validateValue(/* anyValue */) {
        return true;
    },

    validateLiteral(anyValue) {
        return (
        // null or undfeind
            anyValue == null

                // value must be
                // string
                || f.isString(anyValue)

                // or number
                || f.isNumber(anyValue)
                && !f.isNaN(anyValue)

                // or boolean
                || f.isBoolean(anyValue)
        );
    },

    compile(/* left, right */) {
        return "true";
    }
});

Operator.byLiteral = {};
Operator.create = function(literal) {
    let ChildOperator = Operator.byLiteral[ literal.toLowerCase().trim() ];

    if ( !f.isFunction(ChildOperator) ) {
        throw new Error("unknown operator literal: " + literal);
    }

    return new ChildOperator(literal);
};

let extend = Operator.extend;
Operator.extend = function(className, proto) {
    if ( !f.isArray(proto.literal) ) {
        throw new Error("invalid operator class, literal must be array in proto");
    }

    let Parent = this;
    let Child = extend.call(Parent, className, proto);

    proto.literal.forEach(function(literal) {
        if ( literal in Operator.byLiteral ) {
            throw new Error(
                "dublicate literal: " + literal
                    + " ("
                        + className + ", "
                        + Operator.byLiteral[ literal.toLowerCase().trim() ].className
                    + ")"
            );
        }

        Operator.byLiteral[ literal.toLowerCase().trim() ] = Child;
    });

    Child.extend = Parent.extend;

    return Child;
};


export default Operator;
